var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 16.284C50 20.5797 48.5155 24.7058 45.8645 27.7581C39.7622 34.7861 33.8435 42.1147 27.5132 48.8881C26.0622 50.4181 23.7605 50.3623 22.372 48.7631L4.13439 27.7581C-1.37813 21.4089 -1.37813 11.159 4.13439 4.80992C9.70109 -1.60153 18.7698 -1.60153 24.3365 4.80992L24.9995 5.57339L25.662 4.81036C28.331 1.73472 31.966 0 35.7632 0C39.5605 0 43.1952 1.73456 45.8645 4.80992C48.5157 7.86237 50 11.9883 50 16.284Z",
    fill: "#FF5963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.b6d185ce2fb805950256709f4514f32c.svg";
export { ForwardRef as ReactComponent };